export const PROJECT_NOTES_CHANGED_EVENT = 'project-notes-changed';

export type ProjectNotesChangedDetail = {
  projectId: string;
};

export function notifyProjectNotesChanged(projectId: string): void {
  window.dispatchEvent(
    new CustomEvent<ProjectNotesChangedDetail>(PROJECT_NOTES_CHANGED_EVENT, {
      detail: { projectId },
    })
  );
}
